import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import { Grid, Stack as ButtonGroup } from '@mui/material'
import Button from '@mui/material/Button'
import FormInput from 'components/FormInput'
import InputDatePicker from 'components/FormInputDatePicker'
import { teenagerRecordFunctionalities } from 'utils/helpers/funcionalidades'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { SummaryTeenagerType } from 'types/search-teenager.type'

type FormGroupProps = {
  onHasPermission: (permission: string) => boolean
  onResetTable: () => void
}

const FormGroup: React.FC<FormGroupProps> = ({ onHasPermission, onResetTable }) => {
  const { control, reset } = useFormContext<SummaryTeenagerType>()

  const handleReset = (): void => {
    onResetTable()
    reset()
  }

  return (
    <Grid container spacing={2} rowSpacing={2}>
      <Grid item md={6} sm={5} xs={12}>
        <FormInput
          name='nome'
          control={control}
          label='Nome do adolescente'
          placeholder='Informe o nome do adolescente'
          maxLength={60}
        />
      </Grid>
      <Grid item md={6} sm={5} xs={12}>
        <FormInput
          name='nomeSocial'
          control={control}
          label='Nome social'
          placeholder='Informe o nome social'
          maxLength={60}
        />
      </Grid>
      <Grid item md={3} sm={3} xs={12}>
        <InputDatePicker name='dataNascimento' control={control} label='Data de nascimento' />
      </Grid>
      <Grid item md={3} sm={4} xs={12}>
        <FormInput
          name='documento'
          control={control}
          label='Documento'
          placeholder='Informe o n° do documento'
        />
      </Grid>
      <Grid item md={6} sm={5} xs={12}>
        <FormInput
          name='nomeMae'
          control={control}
          label='Nome da mãe'
          placeholder='Informe o nome da mãe do adolescente'
        />
      </Grid>
      <Grid item md={6} sm={5} xs={12}>
        <FormInput
          name='nomePai'
          control={control}
          label='Nome do pai'
          placeholder='Informe o nome do pai do adolescente'
        />
      </Grid>
      <Grid item md={6} sm={5} xs={12}>
        <FormInput
          name='representanteLegal'
          control={control}
          label='Nome do responsável pelo adolescente'
          placeholder='Informe o nome do representante legal do adolescente'
        />
      </Grid>
      {onHasPermission(teenagerRecordFunctionalities.consultar) && (
        <Grid item xs={12}>
          <ButtonGroup direction='row' spacing={2} sx={{ mt: 1 }}>
            <Button variant='outlined' color='secondary' onClick={handleReset}>
              Limpar
            </Button>
            <Button
              variant='contained'
              color='secondary'
              startIcon={<SearchRoundedIcon />}
              type='submit'
            >
              Pesquisar
            </Button>
          </ButtonGroup>
        </Grid>
      )}
    </Grid>
  )
}

export default FormGroup
